export const getActivityLogs = (teamMemberIds=[], startDate="", endDate="") => {
    const query = `
    query{
        activityLogs(
            teamMemberIds: ${JSON.stringify(teamMemberIds)},
            startDate: ${startDate===null ? JSON.stringify("") : JSON.stringify(startDate)},
            endDate: ${endDate===null ? JSON.stringify("") : JSON.stringify(endDate)},
        ){
          previous
          next
          logs{
            id
            actorUsername
            actorFullname
            shortDescription
            longDescription
            data 
            activityType
            activityTs
          }
        }
      }
    `
    return query;
}